import {Component, Input, OnInit} from '@angular/core';
import {VetDoctorVetVisitType, VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController} from "@ionic/angular";
import {VetDoctorVetVisitTypeService} from "../../providers/vet-doctor-vet-visit-type.service";
import {CommonUtils} from "../../utils/common";
import {Subscription} from "rxjs";
import {VetDoctor} from "../../models/vet-clinic.model";

@Component({
  selector: 'app-select-vet-doctor-visit-type-time',
  templateUrl: './select-vet-doctor-visit-type-time.component.html',
  styleUrls: ['./select-vet-doctor-visit-type-time.component.scss'],
})
export class SelectVetDoctorVisitTypeTimeComponent implements OnInit {

  @Input()
  minuteSelected: number;

  @Input()
  vetDoctorVetVisitType: VetDoctorVetVisitType;

  @Input()
  vetDoctor: VetDoctor;

  isBusy: boolean;
  subscriptions: Subscription = new Subscription();

  constructor(private appStateService: AppStateService,
              private modalController: ModalController,
              private vetDoctorVetVisitTypeService: VetDoctorVetVisitTypeService,
              protected commonUtils: CommonUtils) { }


  ngOnInit() {
    this.registerSubscription(this.appStateService.isBusySubject.subscribe(e => this.isBusy = e));
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  onClose() {
    this.modalController.dismiss();
  }


  onSave() {
    this.vetDoctorVetVisitType.minutes = this.minuteSelected;
    this.vetDoctorVetVisitType.multiplier = this.minuteSelected / this.vetDoctor.defaultVisitMinutes;
    this.vetDoctorVetVisitType.vetineoVisitTypeBundle = null;
    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetDoctorVetVisitTypeService.updateVetDoctorVetVisitType(this.vetDoctorVetVisitType).subscribe(r => {
      if (r) {
        this.modalController.dismiss(r, 'EDIT');
        this.appStateService.updateIsBusySubject(false);

      } else {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany czasu typu wizyty");
      }
    },  error => {
      this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany czasu typu wizyty");
      this.appStateService.updateIsBusySubject(false);
    }));

  }

  getMinutes() {
    if (this.vetDoctor.defaultVisitMinutes) {
      return Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number" && (value % this.vetDoctor.defaultVisitMinutes) === 0) as number[];
    } else {
      return [];
    }  }
}
